import type { FC } from 'react';
import { Table } from 'reactstrap';
import { IfElseSwitchWrapper } from './IfElseSwitch.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface IfElseSwitchProps {}

const IfElseSwitch: FC<IfElseSwitchProps> = () => (
<IfElseSwitchWrapper>	
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">If Else &amp; Switch</h1>			
   </header>
   <div className="entry-content clear" itemProp="text">
      <div className="is-layout-flow">
         <p className="text-align-justify">Below is the list of conditional statements :</p>
      </div>
      <Table bordered striped responsive className="text-align-justify">
         <thead>
            <tr>
               <th className="text-align-center" style={{width: '10%'}}><strong>Statement</strong></th>
               <th className="text-align-center" style={{width: '60%'}}><strong>Definition</strong></th>
            </tr>
         </thead>
         <tbody>
            <tr>
               <th className="text-align-center"><strong>If</strong></th>
               <td>
                  <p>The&nbsp;if statement&nbsp;is used to test a condition. It executes a block of code&nbsp;if&nbsp;a specified&nbsp;condition&nbsp;is true.&nbsp;</p>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'if (condition) {\n' +  
                        '  //block of code\n' +
                        '}'
                     }
                  </SyntaxHighlighter>
               </td>
            </tr>
            <tr>
               <th className="text-align-center"><strong>Else</strong></th>
               <td>
                  <p>The else statement executes another block of code, if&nbsp;the&nbsp;same condition&nbsp;is false. Else statement is optional.</p>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'if (condition) {\n'+
                        '  //block of code\n'+
                        '} else {\n'+
                        '  //another block of code\n'+
                        '}'
                     }
                  </SyntaxHighlighter>
               </td>
            </tr>
            <tr>
               <th className="text-align-center"><strong>Ternary operator</strong></th>
               <td>
                  <p>The&nbsp;ternary operator&nbsp;consists of a condition that evaluates to either true or false , plus a value that is returned if the condition is true and another value that is returned if the condition is false.</p>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'variable = (condition) ? expressionTrue : expressionFalse;'
                     }
                  </SyntaxHighlighter>
               </td>
            </tr>
            <tr>
               <th className="text-align-center"><strong>Switch</strong></th>
               <td>
                  <p>The switch statement selects one of the blocks of code to be executed. The value of the expression is compared with the values of each&nbsp;case. If there is a match, the associated block of code is executed.</p>
                  <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                     {
                        'switch (expression) {\n'+
                        'case 1:\n'+
                        '  //block of code\n'+
                        '  break;\n'+
                        'case 2:\n'+
                        '  //block of code\n'+
                        '  break;\n'+
                        'default:\n'+
                        '  //block of code \n'+
                        '}'
                     }
                  </SyntaxHighlighter>
               </td>
            </tr>
         </tbody>
      </Table>
   </div>
</IfElseSwitchWrapper>
);

export default IfElseSwitch;
